import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import FaqAccordion from '@/components/feature/FaqAccordion';
import { faqs } from '@/mocks/faqs';

export default function FaqPreview() {
  const preview = faqs.slice(0, 4);

  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
        <div className="grid gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <SectionHeading
              eyebrow="常见问题"
              title="先把疑问讲清楚"
              desc="关于内容来源、隐私保护、更正机制与维权步骤，这里是最高频的几类问题。"
            />
            <Link
              to="/faq"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 font-label text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
            >
              查看全部问题
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
          <div className="lg:col-span-8">
            <FaqAccordion items={preview} />
          </div>
        </div>
      </div>
    </section>
  );
}